module.exports = __webpack_public_path__ + "static/media/info3.364e9ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stores/steps/info3.png
// module id = 330
// module chunks = 0